export default __webpack_public_path__ + "static/media/google-drive-icon.bb64196a.svg";